import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationAddCommentPage } from 'src/app/modals/organisation-add-comment/organisation-add-comment.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationAddCommentPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationAddCommentPage]
})
export class OrganisationAddCommentPageModule {}
